const config = {
  DEV:{
    baseUrl:'http://localhost:3030/',
  },
  SIT:{
    baseUrl:'http://8.130.108.54:3020/',
  },
  PROD:{
   		// baseUrl:'https://www.yylx8.vip/mall/',
      // baseUrl:'http://120.55.64.120:3020/',
      baseUrl:'https://zipeisong.qiaoxuan.vip/',
  }
}

// module.exports = config.DEV
// module.exports = config.SIT
module.exports = config.PROD



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 1